/** RFC 7807 problem+json 응답 바디. Backend가 모든 에러를 이 형식으로 준다. */
export interface ProblemDetail {
  type?: string
  title?: string
  status?: number
  detail?: string
  instance?: string
}

export class ApiError extends Error {
  readonly status: number
  readonly problem: ProblemDetail

  constructor(status: number, problem: ProblemDetail) {
    super(problem.title ?? problem.detail ?? `요청이 실패했어요 (HTTP ${status})`)
    this.name = 'ApiError'
    this.status = status
    this.problem = problem
  }

  get isUnauthorized(): boolean {
    return this.status === 401
  }

  get isClientError(): boolean {
    return this.status >= 400 && this.status < 500
  }
}

export function isApiError(error: unknown): error is ApiError {
  return error instanceof ApiError
}
